import React, { Component } from 'react'

export class SearchBar extends Component {
    constructor(props) {
        super(props)
        this.inputRef = React.createRef()
    }

    inputChangeHanlder = () => {
        this.props.updateSearch(this.inputRef.current.value)
    }

    searchBarVisibilityHandler = () => {
        this.props.searchBarVisibility();
    }

    render() {
        const isSearchOpened = this.props.isSearchOpen

        return (
            <div className="search-bar-container">
                <button className="show-hide-search" onClick={this.searchBarVisibilityHandler}>{isSearchOpened ? "Hide Search" : "Show Search"}</button>
                {isSearchOpened ? <form className="search-form" onSubmit={(e) => e.preventDefault()}>
                    <input className="search-input" ref={this.inputRef} placeholder="Search Upon Todos" onChange={this.inputChangeHanlder} />
                </form> : null}
            </div>
        )
    }
}

export default SearchBar
